var map = {
	"./click0.mp3": [
		81,
		3
	],
	"./click1.mp3": [
		82,
		4
	],
	"./click2.mp3": [
		83,
		5
	],
	"./click3.mp3": [
		84,
		6
	],
	"./click4.mp3": [
		85,
		7
	],
	"./click5.mp3": [
		86,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 77;
module.exports = webpackAsyncContext;